(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue-property-decorator"), require("vue-fragment"), require("@bloomreach/spa-sdk"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["BloomreachVueSdk"] = factory(require("vue-property-decorator"), require("vue-fragment"), require("@bloomreach/spa-sdk"));
	else
		root["BloomreachVueSdk"] = factory(root["VuePropertyDecorator"], root["Fragment"], root["BloomreachSpaSdk"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__01a6__, __WEBPACK_EXTERNAL_MODULE__6877__, __WEBPACK_EXTERNAL_MODULE__947b__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "dd63");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01a6":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__01a6__;

/***/ }),

/***/ "6877":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6877__;

/***/ }),

/***/ "947b":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__947b__;

/***/ }),

/***/ "dd63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "BrSdk", function() { return /* reexport */ BrSdk; });
__webpack_require__.d(__webpack_exports__, "BrComponent", function() { return /* reexport */ src_BrComponent; });
__webpack_require__.d(__webpack_exports__, "BrManageContentButton", function() { return /* reexport */ src_BrManageContentButton; });
__webpack_require__.d(__webpack_exports__, "BrManageMenuButton", function() { return /* reexport */ src_BrManageMenuButton; });
__webpack_require__.d(__webpack_exports__, "BrPage", function() { return /* reexport */ src_BrPage; });

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: external {"commonjs":"@bloomreach/spa-sdk","commonjs2":"@bloomreach/spa-sdk","root":"BloomreachSpaSdk"}
var spa_sdk_root_BloomreachSpaSdk_ = __webpack_require__("947b");

// EXTERNAL MODULE: external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator","root":"VuePropertyDecorator"}
var external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: external {"commonjs":"vue-fragment","commonjs2":"vue-fragment","root":"Fragment"}
var external_commonjs_vue_fragment_commonjs2_vue_fragment_root_Fragment_ = __webpack_require__("6877");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeComponent.vue?vue&type=template&id=50cf56b0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('br-meta',{attrs:{"meta":_vm.component.getMeta()}},[_vm._t("default",function(){return [(_vm.isContainerItem(_vm.component))?_c('br-node-container-item'):(_vm.isContainer(_vm.component))?_c('br-node-container',_vm._l((_vm.component.getChildren()),function(component,key){return _c('br-node-component',{key:key,attrs:{"component":component}})}),1):(_vm.component.getName() in _vm.mapping)?_c(_vm.mapping[_vm.component.getName()],{tag:"component",attrs:{"component":_vm.component,"page":_vm.page}}):_vm._l((_vm.component.getChildren()),function(component,key){return _c('br-node-component',{key:key,attrs:{"component":component}})})]})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/BrNodeComponent.vue?vue&type=template&id=50cf56b0&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrMeta.vue?vue&type=script&lang=ts&



let BrMetavue_type_script_lang_ts_BrMeta = class BrMeta extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  mounted() {
    this.inject();
  }

  beforeUpdate() {
    var _a;

    (_a = this.clear) === null || _a === void 0 ? void 0 : _a.call(this);
  }

  updated() {
    this.inject();
  }

  beforeDestroy() {
    var _a;

    (_a = this.clear) === null || _a === void 0 ? void 0 : _a.call(this);
  }

  inject() {
    this.clear = this.$vnode.elm && this.meta.render(this.$vnode.elm, this.$vnode.elm);
  }

  update() {
    this.$forceUpdate();
  }

  render(createElement) {
    var _a;

    return ((_a = this.$slots.default) === null || _a === void 0 ? void 0 : _a.length) === 1 ? this.$slots.default[0] : createElement(external_commonjs_vue_fragment_commonjs2_vue_fragment_root_Fragment_["Fragment"], this.$slots.default);
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrMetavue_type_script_lang_ts_BrMeta.prototype, "meta", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Watch"])('meta', {
  deep: false
})], BrMetavue_type_script_lang_ts_BrMeta.prototype, "update", null);

BrMetavue_type_script_lang_ts_BrMeta = __decorate([external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"]], BrMetavue_type_script_lang_ts_BrMeta);
/* harmony default export */ var BrMetavue_type_script_lang_ts_ = (BrMetavue_type_script_lang_ts_BrMeta);
// CONCATENATED MODULE: ./src/BrMeta.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrMetavue_type_script_lang_ts_ = (BrMetavue_type_script_lang_ts_); 
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/BrMeta.vue
var BrMeta_render, BrMeta_staticRenderFns




/* normalize component */

var BrMeta_component = normalizeComponent(
  src_BrMetavue_type_script_lang_ts_,
  BrMeta_render,
  BrMeta_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrMeta = (BrMeta_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeContainerItem.vue?vue&type=template&id=e65f6a0c&
var BrNodeContainerItemvue_type_template_id_e65f6a0c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component.getType() in _vm.mapping)?_c(_vm.mapping[_vm.component.getType()],{tag:"component",attrs:{"component":_vm.component,"page":_vm.page}}):(_vm.TYPE_CONTAINER_ITEM_UNDEFINED in _vm.mapping)?_c(_vm.mapping[_vm.TYPE_CONTAINER_ITEM_UNDEFINED],{tag:"component",attrs:{"component":_vm.component,"page":_vm.page}}):_c('br-container-item-undefined',{attrs:{"component":_vm.component,"page":_vm.page}})}
var BrNodeContainerItemvue_type_template_id_e65f6a0c_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrNodeContainerItem.vue?vue&type=template&id=e65f6a0c&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerItemUndefined.vue?vue&type=template&id=68a5c024&
var BrContainerItemUndefinedvue_type_template_id_68a5c024_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(("Component \"" + (_vm.component.getType()) + "\" is not defined.")))])}
var BrContainerItemUndefinedvue_type_template_id_68a5c024_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrContainerItemUndefined.vue?vue&type=template&id=68a5c024&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerItemUndefined.vue?vue&type=script&lang=ts&



let BrContainerItemUndefinedvue_type_script_lang_ts_BrContainerItemUndefined = class BrContainerItemUndefined extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrContainerItemUndefinedvue_type_script_lang_ts_BrContainerItemUndefined.prototype, "component", void 0);

BrContainerItemUndefinedvue_type_script_lang_ts_BrContainerItemUndefined = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    Fragment: external_commonjs_vue_fragment_commonjs2_vue_fragment_root_Fragment_["Fragment"]
  }
})], BrContainerItemUndefinedvue_type_script_lang_ts_BrContainerItemUndefined);
/* harmony default export */ var BrContainerItemUndefinedvue_type_script_lang_ts_ = (BrContainerItemUndefinedvue_type_script_lang_ts_BrContainerItemUndefined);
// CONCATENATED MODULE: ./src/BrContainerItemUndefined.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerItemUndefinedvue_type_script_lang_ts_ = (BrContainerItemUndefinedvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerItemUndefined.vue





/* normalize component */

var BrContainerItemUndefined_component = normalizeComponent(
  src_BrContainerItemUndefinedvue_type_script_lang_ts_,
  BrContainerItemUndefinedvue_type_template_id_68a5c024_render,
  BrContainerItemUndefinedvue_type_template_id_68a5c024_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerItemUndefined = (BrContainerItemUndefined_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeContainerItem.vue?vue&type=script&lang=ts&




let BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem = class BrNodeContainerItem extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  destroyed() {
    var _a;

    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }

  subscribe() {
    var _a;

    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
    this.unsubscribe = this.component.on('update', this.onUpdate.bind(this));
  }

  onUpdate() {
    this.$forceUpdate();
    this.page.sync();
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem.prototype, "component$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem.prototype, "mapping$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem.prototype, "page$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Watch"])('component', {
  immediate: true
})], BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem.prototype, "subscribe", null);

BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrContainerItemUndefined: src_BrContainerItemUndefined
  },
  computed: {
    component() {
      return this.component$();
    },

    mapping() {
      return this.mapping$();
    },

    page() {
      return this.page$();
    }

  },
  data: () => ({
    TYPE_CONTAINER_ITEM_UNDEFINED: spa_sdk_root_BloomreachSpaSdk_["TYPE_CONTAINER_ITEM_UNDEFINED"]
  })
})], BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem);
/* harmony default export */ var BrNodeContainerItemvue_type_script_lang_ts_ = (BrNodeContainerItemvue_type_script_lang_ts_BrNodeContainerItem);
// CONCATENATED MODULE: ./src/BrNodeContainerItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrNodeContainerItemvue_type_script_lang_ts_ = (BrNodeContainerItemvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrNodeContainerItem.vue





/* normalize component */

var BrNodeContainerItem_component = normalizeComponent(
  src_BrNodeContainerItemvue_type_script_lang_ts_,
  BrNodeContainerItemvue_type_template_id_e65f6a0c_render,
  BrNodeContainerItemvue_type_template_id_e65f6a0c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrNodeContainerItem = (BrNodeContainerItem_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeContainer.vue?vue&type=template&id=5d9c7ba6&
var BrNodeContainervue_type_template_id_5d9c7ba6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component.getType() in _vm.mapping)?_c(_vm.mapping[_vm.component.getType()],{tag:"component",attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2):(_vm.component.getType() === _vm.TYPE_CONTAINER_INLINE)?_c('br-container-inline',{attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2):(_vm.component.getType() === _vm.TYPE_CONTAINER_NO_MARKUP)?_c('br-container-no-markup',{attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2):(_vm.component.getType() === _vm.TYPE_CONTAINER_ORDERED_LIST)?_c('br-container-ordered-list',{attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2):(_vm.component.getType() === _vm.TYPE_CONTAINER_UNORDERED_LIST)?_c('br-container-unordered-list',{attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2):_c('br-container-box',{attrs:{"component":_vm.component,"page":_vm.page}},[_vm._t("default")],2)}
var BrNodeContainervue_type_template_id_5d9c7ba6_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrNodeContainer.vue?vue&type=template&id=5d9c7ba6&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerBox.vue?vue&type=script&lang=ts&


let BrContainerBoxvue_type_script_lang_ts_BrContainerBox = class BrContainerBox extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  render(createElement) {
    var _a;

    return createElement('div', {
      class: {
        'hst-container': this.page.isPreview()
      }
    }, (_a = this.$slots.default) === null || _a === void 0 ? void 0 : _a.map(node => createElement('div', {
      class: {
        'hst-container-item': this.page.isPreview()
      }
    }, [node])));
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrContainerBoxvue_type_script_lang_ts_BrContainerBox.prototype, "page", void 0);

BrContainerBoxvue_type_script_lang_ts_BrContainerBox = __decorate([external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"]], BrContainerBoxvue_type_script_lang_ts_BrContainerBox);
/* harmony default export */ var BrContainerBoxvue_type_script_lang_ts_ = (BrContainerBoxvue_type_script_lang_ts_BrContainerBox);
// CONCATENATED MODULE: ./src/BrContainerBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerBoxvue_type_script_lang_ts_ = (BrContainerBoxvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerBox.vue
var BrContainerBox_render, BrContainerBox_staticRenderFns




/* normalize component */

var BrContainerBox_component = normalizeComponent(
  src_BrContainerBoxvue_type_script_lang_ts_,
  BrContainerBox_render,
  BrContainerBox_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerBox = (BrContainerBox_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerInline.vue?vue&type=script&lang=ts&


let BrContainerInlinevue_type_script_lang_ts_BrContainerInline = class BrContainerInline extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  render(createElement) {
    var _a;

    return createElement('div', {
      class: {
        'hst-container': this.page.isPreview()
      }
    }, (_a = this.$slots.default) === null || _a === void 0 ? void 0 : _a.map(node => createElement('span', {
      class: {
        'hst-container-item': this.page.isPreview()
      }
    }, [node])));
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrContainerInlinevue_type_script_lang_ts_BrContainerInline.prototype, "page", void 0);

BrContainerInlinevue_type_script_lang_ts_BrContainerInline = __decorate([external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"]], BrContainerInlinevue_type_script_lang_ts_BrContainerInline);
/* harmony default export */ var BrContainerInlinevue_type_script_lang_ts_ = (BrContainerInlinevue_type_script_lang_ts_BrContainerInline);
// CONCATENATED MODULE: ./src/BrContainerInline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerInlinevue_type_script_lang_ts_ = (BrContainerInlinevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerInline.vue
var BrContainerInline_render, BrContainerInline_staticRenderFns




/* normalize component */

var BrContainerInline_component = normalizeComponent(
  src_BrContainerInlinevue_type_script_lang_ts_,
  BrContainerInline_render,
  BrContainerInline_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerInline = (BrContainerInline_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerNoMarkup.vue?vue&type=template&id=6599108c&
var BrContainerNoMarkupvue_type_template_id_6599108c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_vm._t("default")],2)}
var BrContainerNoMarkupvue_type_template_id_6599108c_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrContainerNoMarkup.vue?vue&type=template&id=6599108c&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerNoMarkup.vue?vue&type=script&lang=ts&



let BrContainerNoMarkupvue_type_script_lang_ts_BrContainerNoMarkup = class BrContainerNoMarkup extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {};
BrContainerNoMarkupvue_type_script_lang_ts_BrContainerNoMarkup = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    Fragment: external_commonjs_vue_fragment_commonjs2_vue_fragment_root_Fragment_["Fragment"]
  }
})], BrContainerNoMarkupvue_type_script_lang_ts_BrContainerNoMarkup);
/* harmony default export */ var BrContainerNoMarkupvue_type_script_lang_ts_ = (BrContainerNoMarkupvue_type_script_lang_ts_BrContainerNoMarkup);
// CONCATENATED MODULE: ./src/BrContainerNoMarkup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerNoMarkupvue_type_script_lang_ts_ = (BrContainerNoMarkupvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerNoMarkup.vue





/* normalize component */

var BrContainerNoMarkup_component = normalizeComponent(
  src_BrContainerNoMarkupvue_type_script_lang_ts_,
  BrContainerNoMarkupvue_type_template_id_6599108c_render,
  BrContainerNoMarkupvue_type_template_id_6599108c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerNoMarkup = (BrContainerNoMarkup_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerOrderedList.vue?vue&type=script&lang=ts&


let BrContainerOrderedListvue_type_script_lang_ts_BrContainerOrderedList = class BrContainerOrderedList extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  render(createElement) {
    var _a;

    return createElement('ol', {
      class: {
        'hst-container': this.page.isPreview()
      }
    }, (_a = this.$slots.default) === null || _a === void 0 ? void 0 : _a.map(node => createElement('li', {
      class: {
        'hst-container-item': this.page.isPreview()
      }
    }, [node])));
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrContainerOrderedListvue_type_script_lang_ts_BrContainerOrderedList.prototype, "page", void 0);

BrContainerOrderedListvue_type_script_lang_ts_BrContainerOrderedList = __decorate([external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"]], BrContainerOrderedListvue_type_script_lang_ts_BrContainerOrderedList);
/* harmony default export */ var BrContainerOrderedListvue_type_script_lang_ts_ = (BrContainerOrderedListvue_type_script_lang_ts_BrContainerOrderedList);
// CONCATENATED MODULE: ./src/BrContainerOrderedList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerOrderedListvue_type_script_lang_ts_ = (BrContainerOrderedListvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerOrderedList.vue
var BrContainerOrderedList_render, BrContainerOrderedList_staticRenderFns




/* normalize component */

var BrContainerOrderedList_component = normalizeComponent(
  src_BrContainerOrderedListvue_type_script_lang_ts_,
  BrContainerOrderedList_render,
  BrContainerOrderedList_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerOrderedList = (BrContainerOrderedList_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrContainerUnorderedList.vue?vue&type=script&lang=ts&


let BrContainerUnorderedListvue_type_script_lang_ts_BrContainerUnorderedList = class BrContainerUnorderedList extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  render(createElement) {
    var _a;

    return createElement('ul', {
      class: {
        'hst-container': this.page.isPreview()
      }
    }, (_a = this.$slots.default) === null || _a === void 0 ? void 0 : _a.map(node => createElement('li', {
      class: {
        'hst-container-item': this.page.isPreview()
      }
    }, [node])));
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrContainerUnorderedListvue_type_script_lang_ts_BrContainerUnorderedList.prototype, "page", void 0);

BrContainerUnorderedListvue_type_script_lang_ts_BrContainerUnorderedList = __decorate([external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"]], BrContainerUnorderedListvue_type_script_lang_ts_BrContainerUnorderedList);
/* harmony default export */ var BrContainerUnorderedListvue_type_script_lang_ts_ = (BrContainerUnorderedListvue_type_script_lang_ts_BrContainerUnorderedList);
// CONCATENATED MODULE: ./src/BrContainerUnorderedList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrContainerUnorderedListvue_type_script_lang_ts_ = (BrContainerUnorderedListvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrContainerUnorderedList.vue
var BrContainerUnorderedList_render, BrContainerUnorderedList_staticRenderFns




/* normalize component */

var BrContainerUnorderedList_component = normalizeComponent(
  src_BrContainerUnorderedListvue_type_script_lang_ts_,
  BrContainerUnorderedList_render,
  BrContainerUnorderedList_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrContainerUnorderedList = (BrContainerUnorderedList_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeContainer.vue?vue&type=script&lang=ts&








let BrNodeContainervue_type_script_lang_ts_BrNodeContainer = class BrNodeContainer extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainervue_type_script_lang_ts_BrNodeContainer.prototype, "component$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainervue_type_script_lang_ts_BrNodeContainer.prototype, "mapping$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeContainervue_type_script_lang_ts_BrNodeContainer.prototype, "page$", void 0);

BrNodeContainervue_type_script_lang_ts_BrNodeContainer = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrContainerBox: src_BrContainerBox,
    BrContainerInline: src_BrContainerInline,
    BrContainerNoMarkup: src_BrContainerNoMarkup,
    BrContainerOrderedList: src_BrContainerOrderedList,
    BrContainerUnorderedList: src_BrContainerUnorderedList
  },
  computed: {
    component() {
      return this.component$();
    },

    mapping() {
      return this.mapping$();
    },

    page() {
      return this.page$();
    }

  },
  data: () => ({
    TYPE_CONTAINER_INLINE: spa_sdk_root_BloomreachSpaSdk_["TYPE_CONTAINER_INLINE"],
    TYPE_CONTAINER_NO_MARKUP: spa_sdk_root_BloomreachSpaSdk_["TYPE_CONTAINER_NO_MARKUP"],
    TYPE_CONTAINER_ORDERED_LIST: spa_sdk_root_BloomreachSpaSdk_["TYPE_CONTAINER_ORDERED_LIST"],
    TYPE_CONTAINER_UNORDERED_LIST: spa_sdk_root_BloomreachSpaSdk_["TYPE_CONTAINER_UNORDERED_LIST"]
  })
})], BrNodeContainervue_type_script_lang_ts_BrNodeContainer);
/* harmony default export */ var BrNodeContainervue_type_script_lang_ts_ = (BrNodeContainervue_type_script_lang_ts_BrNodeContainer);
// CONCATENATED MODULE: ./src/BrNodeContainer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrNodeContainervue_type_script_lang_ts_ = (BrNodeContainervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrNodeContainer.vue





/* normalize component */

var BrNodeContainer_component = normalizeComponent(
  src_BrNodeContainervue_type_script_lang_ts_,
  BrNodeContainervue_type_template_id_5d9c7ba6_render,
  BrNodeContainervue_type_template_id_5d9c7ba6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrNodeContainer = (BrNodeContainer_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrNodeComponent.vue?vue&type=script&lang=ts&






let BrNodeComponentvue_type_script_lang_ts_BrNodeComponent = class BrNodeComponent extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  component$() {
    return this.component;
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrNodeComponentvue_type_script_lang_ts_BrNodeComponent.prototype, "component", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeComponentvue_type_script_lang_ts_BrNodeComponent.prototype, "mapping$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrNodeComponentvue_type_script_lang_ts_BrNodeComponent.prototype, "page$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Provide"])() // ProvideReactive doesn't work with recursive components
], BrNodeComponentvue_type_script_lang_ts_BrNodeComponent.prototype, "component$", null);

BrNodeComponentvue_type_script_lang_ts_BrNodeComponent = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrMeta: src_BrMeta,
    BrNodeContainerItem: src_BrNodeContainerItem,
    BrNodeContainer: src_BrNodeContainer
  },
  computed: {
    mapping() {
      return this.mapping$();
    },

    page() {
      return this.page$();
    }

  },
  methods: {
    isContainerItem: spa_sdk_root_BloomreachSpaSdk_["isContainerItem"],
    isContainer: spa_sdk_root_BloomreachSpaSdk_["isContainer"]
  },
  name: 'br-node-component'
})], BrNodeComponentvue_type_script_lang_ts_BrNodeComponent);
/* harmony default export */ var BrNodeComponentvue_type_script_lang_ts_ = (BrNodeComponentvue_type_script_lang_ts_BrNodeComponent);
// CONCATENATED MODULE: ./src/BrNodeComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrNodeComponentvue_type_script_lang_ts_ = (BrNodeComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrNodeComponent.vue





/* normalize component */

var BrNodeComponent_component = normalizeComponent(
  src_BrNodeComponentvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrNodeComponent = (BrNodeComponent_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrComponent.vue?vue&type=script&lang=ts&





/**
 * The brXM component.
 */

let BrComponentvue_type_script_lang_ts_BrComponent = class BrComponent extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  getComponents() {
    if (Object(spa_sdk_root_BloomreachSpaSdk_["isComponent"])(this.component)) {
      return [this.component];
    }

    if (!this.parent) {
      return [];
    }

    if (!this.component) {
      return this.parent.getChildren();
    }

    const component = this.parent.getComponent(...this.component.split('/'));
    return component ? [component] : [];
  }

  render(createElement) {
    const components = this.getComponents().map(component => {
      var _a, _b;

      return createElement(src_BrNodeComponent, {
        props: {
          component
        }
      }, (_b = (_a = this.$scopedSlots).default) === null || _b === void 0 ? void 0 : _b.call(_a, {
        component,
        page: this.page
      }));
    });
    return components.length > 1 ? createElement(external_commonjs_vue_fragment_commonjs2_vue_fragment_root_Fragment_["Fragment"], components) : components[0];
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrComponentvue_type_script_lang_ts_BrComponent.prototype, "component", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrComponentvue_type_script_lang_ts_BrComponent.prototype, "page$", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])('component$')], BrComponentvue_type_script_lang_ts_BrComponent.prototype, "parent$", void 0);

BrComponentvue_type_script_lang_ts_BrComponent = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  computed: {
    page() {
      var _a;

      return (_a = this.page$) === null || _a === void 0 ? void 0 : _a.call(this);
    },

    parent() {
      var _a;

      return (_a = this.parent$) === null || _a === void 0 ? void 0 : _a.call(this);
    }

  },
  name: 'br-component'
})], BrComponentvue_type_script_lang_ts_BrComponent);
/* harmony default export */ var BrComponentvue_type_script_lang_ts_ = (BrComponentvue_type_script_lang_ts_BrComponent);
// CONCATENATED MODULE: ./src/BrComponent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrComponentvue_type_script_lang_ts_ = (BrComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrComponent.vue
var BrComponent_render, BrComponent_staticRenderFns




/* normalize component */

var BrComponent_component = normalizeComponent(
  src_BrComponentvue_type_script_lang_ts_,
  BrComponent_render,
  BrComponent_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrComponent = (BrComponent_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrManageContentButton.vue?vue&type=template&id=9df57f1c&
var BrManageContentButtonvue_type_template_id_9df57f1c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page && _vm.page.isPreview())?_c('br-meta',{attrs:{"meta":_vm.meta}}):_vm._e()}
var BrManageContentButtonvue_type_template_id_9df57f1c_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrManageContentButton.vue?vue&type=template&id=9df57f1c&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrManageContentButton.vue?vue&type=script&lang=ts&




/**
 * The button component that opens for editing a content.
 */

let BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton = class BrManageContentButton extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "content", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "documentTemplateQuery", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "folderTemplateQuery", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "path", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "parameter", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerConfiguration", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerEnableUpload", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerInitialPath", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerRemembersLastVisited", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerRootPath", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "pickerSelectableNodeTypes", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "relative", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "root", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton.prototype, "page$", void 0);

BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrMeta: src_BrMeta
  },
  computed: {
    meta() {
      var _a;

      return (_a = this.page) === null || _a === void 0 ? void 0 : _a.getButton(spa_sdk_root_BloomreachSpaSdk_["TYPE_MANAGE_CONTENT_BUTTON"], this.$props);
    },

    page() {
      var _a;

      return (_a = this.page$) === null || _a === void 0 ? void 0 : _a.call(this);
    }

  },
  name: 'br-manage-content-button'
})], BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton);
/* harmony default export */ var BrManageContentButtonvue_type_script_lang_ts_ = (BrManageContentButtonvue_type_script_lang_ts_BrManageContentButton);
// CONCATENATED MODULE: ./src/BrManageContentButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrManageContentButtonvue_type_script_lang_ts_ = (BrManageContentButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrManageContentButton.vue





/* normalize component */

var BrManageContentButton_component = normalizeComponent(
  src_BrManageContentButtonvue_type_script_lang_ts_,
  BrManageContentButtonvue_type_template_id_9df57f1c_render,
  BrManageContentButtonvue_type_template_id_9df57f1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrManageContentButton = (BrManageContentButton_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrManageMenuButton.vue?vue&type=template&id=18bf669e&
var BrManageMenuButtonvue_type_template_id_18bf669e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page && _vm.page.isPreview())?_c('br-meta',{attrs:{"meta":_vm.meta}}):_vm._e()}
var BrManageMenuButtonvue_type_template_id_18bf669e_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrManageMenuButton.vue?vue&type=template&id=18bf669e&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrManageMenuButton.vue?vue&type=script&lang=ts&




/**
 * The button component that opens a menu editor.
 */

let BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton = class BrManageMenuButton extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton.prototype, "menu", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Inject"])()], BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton.prototype, "page$", void 0);

BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrMeta: src_BrMeta
  },
  computed: {
    meta() {
      var _a;

      return (_a = this.page) === null || _a === void 0 ? void 0 : _a.getButton(spa_sdk_root_BloomreachSpaSdk_["TYPE_MANAGE_MENU_BUTTON"], this.menu);
    },

    page() {
      var _a;

      return (_a = this.page$) === null || _a === void 0 ? void 0 : _a.call(this);
    }

  },
  name: 'br-manage-menu-button'
})], BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton);
/* harmony default export */ var BrManageMenuButtonvue_type_script_lang_ts_ = (BrManageMenuButtonvue_type_script_lang_ts_BrManageMenuButton);
// CONCATENATED MODULE: ./src/BrManageMenuButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrManageMenuButtonvue_type_script_lang_ts_ = (BrManageMenuButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrManageMenuButton.vue





/* normalize component */

var BrManageMenuButton_component = normalizeComponent(
  src_BrManageMenuButtonvue_type_script_lang_ts_,
  BrManageMenuButtonvue_type_template_id_18bf669e_render,
  BrManageMenuButtonvue_type_template_id_18bf669e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrManageMenuButton = (BrManageMenuButton_component.exports);
// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0faf6375-vue-loader-template"}!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrPage.vue?vue&type=template&id=62f057a0&
var BrPagevue_type_template_id_62f057a0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state)?_c('br-node-component',{attrs:{"component":_vm.root}},[_vm._t("default",null,{"component":_vm.root,"page":_vm.state})],2):_vm._e()}
var BrPagevue_type_template_id_62f057a0_staticRenderFns = []


// CONCATENATED MODULE: ./src/BrPage.vue?vue&type=template&id=62f057a0&

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--13-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/thread-loader/dist/cjs.js!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/babel-loader/lib!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader??ref--13-3!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/cache-loader/dist/cjs.js??ref--0-0!/var/lib/jenkins/workspace/spa-sdk_main/node_modules/vue-loader/lib??vue-loader-options!./src/BrPage.vue?vue&type=script&lang=ts&




/**
 * The brXM page.
 */

let BrPagevue_type_script_lang_ts_BrPage = class BrPage extends external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Vue"] {
  mapping$() {
    return this.mapping;
  }

  page$() {
    return this.state;
  }

  serverPrefetch() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.loading;
    });
  }

  destroyed() {
    this.destroy();
  }

  mounted() {
    var _a;

    (_a = this.state) === null || _a === void 0 ? void 0 : _a.sync();
  }

  updated() {
    var _a;

    (_a = this.state) === null || _a === void 0 ? void 0 : _a.sync();
  }

  update(current, previous) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!previous && this.page) {
        this.state = Object(spa_sdk_root_BloomreachSpaSdk_["initialize"])(this.configuration, this.page);
        return;
      }

      this.destroy();
      this.loading = Object(spa_sdk_root_BloomreachSpaSdk_["initialize"])(this.configuration);
      this.state = yield this.loading;
      delete this.loading;
    });
  }

  destroy() {
    if (this.state) {
      Object(spa_sdk_root_BloomreachSpaSdk_["destroy"])(this.state);
    }
  }

};

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrPagevue_type_script_lang_ts_BrPage.prototype, "configuration", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrPagevue_type_script_lang_ts_BrPage.prototype, "mapping", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Prop"])()], BrPagevue_type_script_lang_ts_BrPage.prototype, "page", void 0);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Provide"])()], BrPagevue_type_script_lang_ts_BrPage.prototype, "mapping$", null);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Provide"])()], BrPagevue_type_script_lang_ts_BrPage.prototype, "page$", null);

__decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Watch"])('configuration', {
  immediate: true,
  deep: true
})], BrPagevue_type_script_lang_ts_BrPage.prototype, "update", null);

BrPagevue_type_script_lang_ts_BrPage = __decorate([Object(external_commonjs_vue_property_decorator_commonjs2_vue_property_decorator_root_VuePropertyDecorator_["Component"])({
  components: {
    BrNodeComponent: src_BrNodeComponent
  },
  computed: {
    root() {
      var _a;

      return (_a = this.state) === null || _a === void 0 ? void 0 : _a.getComponent();
    }

  },
  data: () => ({
    state: undefined
  }),
  name: 'br-page'
})], BrPagevue_type_script_lang_ts_BrPage);
/* harmony default export */ var BrPagevue_type_script_lang_ts_ = (BrPagevue_type_script_lang_ts_BrPage);
// CONCATENATED MODULE: ./src/BrPage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_BrPagevue_type_script_lang_ts_ = (BrPagevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/BrPage.vue





/* normalize component */

var BrPage_component = normalizeComponent(
  src_BrPagevue_type_script_lang_ts_,
  BrPagevue_type_template_id_62f057a0_render,
  BrPagevue_type_template_id_62f057a0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_BrPage = (BrPage_component.exports);
// CONCATENATED MODULE: ./src/main.ts
/*
 * Copyright 2020 Bloomreach
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * The brXM SDK plugin.
 */

function BrSdk(vue) {
  vue.component('br-component', src_BrComponent);
  vue.component('br-manage-content-button', src_BrManageContentButton);
  vue.component('br-manage-menu-button', src_BrManageMenuButton);
  vue.component('br-page', src_BrPage);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/spa-sdk_main/node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
});
//# sourceMappingURL=index.umd.js.map